class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }


  connectedCallback() {
    this.validateQtyRules();
  }

  disconnectedCallback() {
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}



class FeaturedProducts extends HTMLElement {
  constructor() {
    super();
    try {
      this.symbol = this.getAttribute('data-price-symbol');
      this.initShowMoreEvent();
      this.initCard3TitleHeight();
      this.scheduleSaleWindow();
      this.initInlineBundles();
      this.initDialogBundles();
    } catch (error) {
      console.error('FeaturedProducts init failed', error);
    }
  }

  connectedCallback() {
    const startSwiper = () => this.initSwiperMb();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startSwiper, { once: true });
    } else {
      startSwiper();
    }
  }

  disconnectedCallback() {
    if (this._saleTimer) {
      window.clearTimeout(this._saleTimer);
      this._saleTimer = null;
    }
  }

  /**
   * @param {HTMLElement} checkBox 
   * @param {HTMLElement} quantityInput 
   */
  update(checkBox, quantityInput) {
    const bundleElement = checkBox.closest('li');
    const cardProduct = bundleElement?.closest('.card-product-3');
    if (!cardProduct) return;

    if (checkBox.checked) {
      cardProduct.querySelectorAll('.card-product-3__bundles li').forEach(bundle => {
        const otherCheckBox = bundle.querySelector('input[type="checkbox"]');
        if (otherCheckBox && otherCheckBox !== checkBox && otherCheckBox.checked) {
          otherCheckBox.checked = false;
          this.update(otherCheckBox, bundle.querySelector('input[data-quantity-variant-id]'));
        }
      });
    }

    const bundleVariantId = bundleElement.getAttribute('data-bundle-variant-id');
    const buyButton = cardProduct.querySelector('buy-now-button');
    const addButton = cardProduct.querySelector('add-cart-button');
    const sourceButton = addButton || buyButton;
    if (!sourceButton) return;
    let ids = (sourceButton.getAttribute('data-variant-id') || '').split(',');
    let quantityList = (sourceButton.getAttribute('data-quantity') || '').split(',');
    if (checkBox.checked) {
      bundleElement.classList.add('active');
      const findIndex = ids.findIndex((id) => id == bundleVariantId);
      if (findIndex <= -1) {
        // add id, quantity
        ids.push(bundleVariantId);
        quantityList?.push(quantityInput.value > 1 ? quantityInput.value : 1);
      } else {
        // update quantity
        quantityList[findIndex] = quantityInput.value > 1 ? quantityInput.value : 1;
      }
    } else {
      const findIndex = ids.findIndex((id) => id == bundleVariantId);
      if (findIndex > -1) {
        // remove id, quantity
        ids.splice(findIndex, 1);
        quantityList.splice(findIndex, 1);
      }
      bundleElement.classList.remove('active');
    }
    buyButton?.setAttribute('data-variant-id', ids.join(','));
    buyButton?.setAttribute('data-quantity', quantityList.join(','));
    addButton?.setAttribute('data-variant-id', ids.join(','));
    addButton?.setAttribute('data-quantity', quantityList.join(','));

    // Update bundle price 
    const bundlePriceElement = bundleElement.querySelector('[data-bundle-price]');
    if (bundlePriceElement) {
      const bundlePrice = Number(bundlePriceElement.getAttribute('data-bundle-price'));
      const bundleComparePriceElement = bundleElement.querySelector('[data-bundle-compare-price]');
      const bundleComparePrice = bundleComparePriceElement ? Number(bundleComparePriceElement.getAttribute('data-bundle-compare-price')) : 0;
      const quantityEle = bundleElement.querySelector('[data-quantity-variant-id]');
      const quantity = quantityEle ? quantityEle.value : 1;
      const finalPrice = quantity * bundlePrice;
      const finalComparePrice = quantity * bundleComparePrice;
      bundlePriceElement.innerHTML = this.formatMoney(finalPrice);
      if (bundleComparePriceElement) {
        bundleComparePriceElement.innerHTML = finalPrice < finalComparePrice
          ? this.formatMoney(finalComparePrice)
          : '';
      }
    }
    this.renderMainPrice(cardProduct);
  }

  /**
   * @param {HTMLElement} cardProduct 
   */
  renderMainPrice(cardProduct) {
    const priceElement = cardProduct.querySelector('[data-price]');
    const comparePriceElement = cardProduct.querySelector('[data-compare-price]');
    const price = priceElement ? Number(priceElement.getAttribute('data-price')) : 0;
    const comparePrice = comparePriceElement ? Number(comparePriceElement.getAttribute('data-compare-price')) : 0;

    let finalPrice = price;
    let finalComparePrice = comparePrice;
    for (const bundle of cardProduct.querySelectorAll('.card-product-3__bundle')) {
      const checkbox = bundle.querySelector('[type="checkbox"]');
      const isChecked = checkbox?.checked;
      if (isChecked) {
        const bundlePrice = Number(bundle.querySelector('[data-bundle-price]').getAttribute('data-bundle-price'));
        const bundlePriceElement = bundle.querySelector('[data-bundle-compare-price]');
        const bundleComparePrice = bundlePriceElement ? Number(bundlePriceElement.getAttribute('data-bundle-compare-price')) : bundlePrice;
        const quantityEle = bundle.querySelector('[data-quantity-variant-id]');
        const quantity = quantityEle ? quantityEle.value : 1;
        finalPrice += (quantity * bundlePrice);
        finalComparePrice += (quantity * bundleComparePrice);
      }
    }
    if (priceElement) priceElement.innerHTML = this.formatMoney(finalPrice)
    else console.warn("renderMainPrice: priceElement not found.");
    if (comparePriceElement){
      comparePriceElement.innerHTML = finalPrice < finalComparePrice
      ? this.formatMoney(finalComparePrice)
      : '';
    }
  }


  initInlineBundles() {
    const bundles = this.querySelectorAll('.card-product-3 .card-product-3__bundles > li');
    for (const bundle of bundles) {
      const checkBox = bundle.querySelector('input[type="checkbox"]');
      if (!checkBox) continue;
      const quantityInput = bundle.querySelector('input[data-quantity-variant-id]');

      if (quantityInput) {
        this.update(checkBox, quantityInput);
        checkBox.addEventListener('change', () => {
          this.update(checkBox, quantityInput);
        });
        quantityInput.addEventListener('change', () => {
          this.update(checkBox, quantityInput);
        });
      } else {
        this.update(checkBox, { value: 1 });
        checkBox.addEventListener('change', () => {
          this.update(checkBox, { value: 1 });
        });
      }
    }
  }

  initDialogBundles() {
    this.querySelectorAll('[data-bundle-dialog]').forEach((popup) => {
      const blockId = popup.getAttribute('data-block-id');
      const card = this.querySelector(`.card-product-3[data-block-id="${blockId}"]`);
      if (!card) return;

      this.rememberMainVariant(card);

      card.querySelector('.dialog-show-btn')?.addEventListener('click', (event) => {
        event.preventDefault();
        this.openBundleDialog(popup);
      });

      popup.querySelectorAll('li.card-product-3__bundle:not(.sell-out)').forEach((bundle) => {
        bundle.addEventListener('click', (event) => {
          if (event.target.closest('a')) return;
          this.onDialogBundleInteract(popup, bundle);
        });
        bundle.addEventListener('change', (event) => {
          if (!event.target.classList?.contains('quantity_input')) return;
          this.onDialogBundleInteract(popup, bundle);
        });
      });

      popup.querySelector('.popup__close-btn')?.addEventListener('click', () => {
        this.closeBundleDialog(popup);
      });

      popup.querySelector('.popup__done-btn')?.addEventListener('click', (event) => {
        const doneBtn = event.currentTarget;
        if (doneBtn.disabled || doneBtn.getAttribute('aria-disabled') === 'true') return;
        this.applyDialogBundle(popup, card);
        card.querySelector('add-cart-button')?.click();
        this.closeBundleDialog(popup);
      });
    });
  }

  rememberMainVariant(card) {
    if (card.dataset.mainVariantId) return;
    const anchor = card.querySelector('add-cart-button') || card.querySelector('buy-now-button');
    if (!anchor) return;
    const ids = (anchor.getAttribute('data-variant-id') || '').split(',').filter(Boolean);
    const quantities = (anchor.getAttribute('data-quantity') || '').split(',').filter(Boolean);
    card.dataset.mainVariantId = ids[0] || '';
    card.dataset.mainQuantity = quantities[0] || '1';
  }

  onDialogBundleInteract(popup, bundle) {
    const input = bundle.querySelector('.quantity_input');
    const quantity = input ? parseInt(input.value, 10) || 0 : 1;
    const selected = input ? quantity > 0 : !bundle.classList.contains('selected');

    popup.querySelectorAll('li.card-product-3__bundle').forEach((other) => {
      if (other === bundle) return;
      other.classList.remove('selected', 'active');
      const checkbox = other.querySelector('input[type="checkbox"]');
      if (checkbox) checkbox.checked = false;
    });

    bundle.classList.toggle('selected', selected);
    bundle.classList.toggle('active', selected);
    const checkbox = bundle.querySelector('input[type="checkbox"]');
    if (checkbox) checkbox.checked = selected;
    popup.dispatchEvent(new CustomEvent('bts26:bundle-selection-change', { bubbles: true }));
  }

  applyDialogBundle(popup, card) {
    const addButton = card.querySelector('add-cart-button');
    const buyButton = card.querySelector('buy-now-button');
    const mainId = card.dataset.mainVariantId || '';
    const mainQuantity = card.dataset.mainQuantity || '1';
    const ids = mainId ? [mainId] : [];
    const quantities = mainId ? [mainQuantity] : [];

    popup.querySelectorAll('li.card-product-3__bundle.selected:not(.sell-out)').forEach((bundle) => {
      const variantId = bundle.getAttribute('data-bundle-variant-id');
      if (!variantId) return;
      const input = bundle.querySelector('.quantity_input');
      const quantity = input ? Math.max(parseInt(input.value, 10) || 0, 1) : 1;
      ids.push(variantId);
      quantities.push(String(quantity));
    });

    const idsValue = ids.join(',');
    const quantityValue = quantities.join(',');
    [addButton, buyButton].forEach((button) => {
      if (!button) return;
      button.setAttribute('data-variant-id', idsValue);
      button.setAttribute('data-quantity', quantityValue);
    });
  }

  openBundleDialog(popup) {
    if (window.jQuery) window.jQuery(popup).fadeIn();
    else popup.style.display = 'block';
  }

  closeBundleDialog(popup) {
    if (window.jQuery) window.jQuery(popup).fadeOut();
    else popup.style.display = 'none';
  }

  formatMoney(cents, format) {
    var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || priceFormat?.moneyFormat || moneyFormat || this.getAttribute("data-money-format");

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      if (dollarsAmount.length === 5) dollarsAmount = dollarsAmount.replace('.', ''); // 千元不需要分隔符
      parts[1] = parts[1] === '00' ? '' : parts[1]; // 小数点后面如果是00，不需要显示
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2, '.', ',');
    }

    // xxx € 格式（金额在前，货币符号在后）
    let unit = formatString.replace(placeholderRegex, '');
    return value + ' ' + unit;
  }

  finishShowMoreLayout() {
    this.classList.remove('is-showmore-pending');
    this.equalizeCard3TitleHeights();
  }

  /** show more / Swiper 布局完成后再把同一组 card3 的标题容器拉成一样高 */
  equalizeCard3TitleHeights() {
    const els = this.querySelectorAll('.card-product-3__content .card-product-3__title-container');
    if (!els.length) return;
    els.forEach((el) => {
      el.style.height = 'auto';
    });
    let max = 0;
    els.forEach((el) => {
      const h = el.getBoundingClientRect().height;
      if (h > max) max = h;
    });
    els.forEach((el) => {
      el.style.height = `${max}px`;
    });
  }

  initCard3TitleHeight() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this.equalizeCard3TitleHeights(), 120);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.equalizeCard3TitleHeights());
    }
  }

  initShowMoreEvent() {
    const finish = () => this.finishShowMoreLayout();
    if (window.innerWidth <= 850) {
      finish();
      return;
    }
    const itemContainer = this.querySelector('.bfcm-featured-products__products-container-inner .swiper-wrapper');
    if (!itemContainer || !itemContainer.classList.contains('need-show-more')) {
      finish();
      return;
    }

    const columnsPerRow = 3;
    const showMoreLimit = Math.max(
      1,
      Number.parseInt(this.getAttribute('data-show-more-limit'), 10) || 9
    );
    const visibleRows = Math.ceil(showMoreLimit / columnsPerRow);
    const items = Array.from(itemContainer.children);
    const itemNum = itemContainer.childElementCount;
    const rowNum = Math.ceil(itemNum / columnsPerRow);
    const showMoreBtn = this.querySelector('.bfcm-featured-products__show-more-btn');

    const itemBoxNormal = document.createElement('div');
    const itemBoxExpand = document.createElement('div');
    itemContainer.innerHTML = '';
    itemBoxNormal.className = 'normal-box';
    itemBoxNormal.style.setProperty('grid-template-rows', `repeat(${visibleRows}, auto)`);

    itemBoxExpand.className = 'expand-box';
    itemBoxExpand.style.setProperty('grid-template-rows', `repeat(${Math.max(0, rowNum - visibleRows)}, auto)`);

    items.forEach((item, index) => {
      if (index < showMoreLimit) {
        itemBoxNormal.appendChild(item);
      } else {
        itemBoxExpand.appendChild(item);
      }
    });
    itemContainer.appendChild(itemBoxNormal);
    itemContainer.appendChild(itemBoxExpand);

    if (itemNum <= showMoreLimit && showMoreBtn) {
      showMoreBtn.style.setProperty('display', 'none');
      itemBoxNormal.style.setProperty('grid-template-rows', `repeat(${rowNum}, auto)`);
    }

    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', () => {
        itemContainer.classList.toggle('collapsed');
        itemContainer.classList.toggle('expanded');
      });
    }

    requestAnimationFrame(finish);
  }

  isSaleWindowEnabled() {
    return this.getAttribute('data-enable-cover') === 'true'
      && this.getAttribute('data-remove-cover-nightly') === 'true';
  }

  isSaleOpen() {
    const openHour = Number.parseInt(this.getAttribute('data-sale-open-hour'), 10);
    const hour = Number.isNaN(openHour) ? 20 : openHour;
    return new Date().getHours() >= hour;
  }

  syncSaleWindow() {
    if (!this.isSaleWindowEnabled()) return;

    const saleOpen = this.isSaleOpen();
    this.setAttribute('data-sale-open', saleOpen ? 'true' : 'false');

    this.querySelectorAll('.need-cover .card-product-3__cover').forEach((cover) => {
      cover.style.display = saleOpen ? 'none' : 'block';
    });

    this.querySelectorAll('[data-sale-gated="true"]').forEach((button) => {
      if (saleOpen) {
        if (button.getAttribute('data-sale-locked') === 'true') {
          button.removeAttribute('aria-disabled');
          button.removeAttribute('data-sale-locked');
        }
        return;
      }
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('data-sale-locked', 'true');
    });
  }

  scheduleSaleWindow() {
    if (!this.isSaleWindowEnabled()) return;
    this.syncSaleWindow();
    const now = new Date();
    const nextHour = new Date(now);
    nextHour.setHours(now.getHours() + 1, 0, 0, 0);
    const delay = Math.max(1000, nextHour.getTime() - now.getTime() + 50);
    this._saleTimer = window.setTimeout(() => this.scheduleSaleWindow(), delay);
  }

  initSwiperMb() {
    if (this.swiperMb) return;
    if (!this.classList.contains('enable-swiper-mb')) return;
    if (window.innerWidth > 850) return;
    if (typeof Swiper === 'undefined') return;

    const swiperEl = this.getAttribute('data-swiper-selector') || this.querySelector('.swiper-container');
    if (!swiperEl) return;

    const options = {
      slidesPerView: 1,
      spaceBetween: 20,
      breakpoints: {
        589: {
          slidesPerView: Number(this.getAttribute('data-swiper-mb-num')) || 1.2,
          spaceBetween: 10
        },
        1024: {
          slidesPerView: Number(this.getAttribute('data-swiper-ipad-num')) || 2,
          spaceBetween: 15
        }
      }
    };

    if (this.getAttribute('data-enable-normalize-slide') === 'true') {
      options.normalizeSlideIndex = false;
    }

    if (this.getAttribute('data-enable-pagination') === 'true') {
      const paginationEl = this.getAttribute('data-pagination-selector') || this.querySelector('.swiper-pagination');
      if (paginationEl) {
        options.pagination = {
          el: paginationEl,
          clickable: true
        };
        if (this.getAttribute('data-enable-progress-bar') === 'true') {
          options.pagination.type = 'progressbar';
        }
        if (this.getAttribute('data-enable-pagination-progress') === 'true') {
          options.pagination.progressbarFillClass = 'pagination-progressbar-fill';
        }
      }
    }

    this.swiperMb = new Swiper(swiperEl, options);
    const equalizeAfterSwiper = () => this.equalizeCard3TitleHeights();
    this.swiperMb.on('resize', equalizeAfterSwiper);
    this.swiperMb.on('breakpoint', equalizeAfterSwiper);
    requestAnimationFrame(equalizeAfterSwiper);
  }
}

if (!customElements.get('common-featured-products')) {
  customElements.define('common-featured-products', FeaturedProducts);
}




